export default __webpack_public_path__ + "eqp_seal_silver.d17d494ffcee87afeb69.png";